import styled from 'styled-components';
var RadioGroup = styled.div.withConfig({
  displayName: "RadioGroup",
  componentId: "io7ggk-0"
})([""]);
export default RadioGroup;